import { useSuspenseQuery } from "@tanstack/react-query"
import { DEFAULT_STALE_TIME } from "toptaal-shared"
import { getMe } from "../services/user"
import { userQueryKeys } from "../query-keys/users"
import { useEffect } from "react"
import { useAuthStore } from "@/stores/useAuthStore"

export const useCurrentUserSuspenseQuery = () => {
  const setUser = useAuthStore((state) => state.setUser)

  const query = useSuspenseQuery({
    queryKey: userQueryKeys.current(),
    queryFn: getMe,
    staleTime: DEFAULT_STALE_TIME,
  })
  const { data } = query

  useEffect(() => {
    if (data) {
      setUser(data.data)
    }
  }, [data, setUser])

  return query
}
